module.exports = __webpack_public_path__ + "img/lenovo.a0da1b7d.svg";